import ActivityFeed from "../../component/Dashboard/ActivityFeed";
import LineChart from "../../component/Dashboard/LineChart";

const WeeklyActivity = ({ weeklyActivityData, recentActivities }) => {
  return (
    <div className="row g-4 mb-4">
      <div className="col-12 col-xl-8">
        <LineChart
          data={weeklyActivityData}
          title="Weekly Activity"
          subtitle="Contacts sent and responses received"
          height={300}
        />
      </div>
      <div className="col-12 col-xl-4">
        <ActivityFeed
          activities={recentActivities}
          title="Recent Activity"
          subtitle="Latest system events"
        />
      </div>
    </div>
  );
};

export default WeeklyActivity;
